import"react";import{isBrowser as o}from"./misc/util.js";o&&window.navigator&&window.navigator.platform&&/iP(ad|hone|od)/.test(window.navigator.platform);
//# sourceMappingURL=useLockBodyScroll.js.map
